var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 244,
    height: 8,
    viewBox: "0 0 244 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74223 7.9441C22.8637 8.28302 40.8005 6.99512 57.1067 6.38506C78.3047 5.63944 99.9104 5.09716 121.516 4.82603C140.676 4.62267 159.836 4.69046 178.995 5.02937C197.747 5.36829 216.907 6.38506 235.659 5.50386C242.997 5.16494 247.481 3.26699 240.551 2.38579C224.653 0.35227 205.493 0.216703 186.333 0.0811356C163.504 -0.122215 140.676 0.0811375 117.847 0.420059C97.4644 0.75898 77.4894 1.30125 57.5143 2.11466C39.1699 2.99586 15.1183 3.87705 1.66568 6.31728C-2.0032 6.92734 0.850376 7.87631 5.74223 7.9441Z",
    fill: "#7D34D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleBar);
export default __webpack_public_path__ + "static/media/purple_bar.67ec083bfb628720ca52b077fd9fdaa2.svg";
export { ForwardRef as ReactComponent };